const features = {
  facebookMessenger: 'facebookMessenger',
  brandRating: 'brandRating',
  changeFrequency: 'changeFrequency',
  useLob: 'useLob',
  payPalSwitchBanner: 'payPalSwitchBanner',
  unsubscribeProlonged: 'unsubscribeProlonged',
  breastCancer: 'breastCancer',
  onboardingToolTips: 'onboardingToolTips',
  twoThreePerfumesPopup: '2-3 perfumes popup', // TODO remove is deleted
  cardFailedPopupWithDiscount: 'Card failed popup with discount',
  giftSetsSubHeaderBanner: 'giftSetsSubHeaderBanner',
  resubscribeReminderPopup: 'resubscribeReminderPopup',
  giftsetDiscountInfo: 'giftsetDiscountInfo',
  beautyBag: 'beautyBag',
  giftSetsDiscount: 'giftSetsDiscount',
  giftSetsMenOnlyDiscount: 'giftSetsMenOnlyDiscount',
  isGoogleBot: 'isGoogleBot',
  resubscribeUnpaid: 'RESUBSCRIBE_UNPAID',
  applePay: 'applePay',
  applePayEcommerce: 'applePayEcommerce',
  scentbirdCandles: 'scentbirdCandles',
  fbPluginOnProductPage: 'fbPluginOnProductPage', // TODO: remove
  queuePopup: 'queuePopup',
  queueUpgradePopup: 'queueUpgradePopup',
  applePayCardUpdate: 'applePayCardUpdate',
  casesBanner: 'casesBanner',
  inviteBanner: 'inviteBanner',
  facebookCheckboxRegistration: 'facebookCheckboxRegistration',
  newProductPopup: 'newProductPopup',
  twoProductsFor25: 'twoProductsFor25',
  twoFor25MemorialDay: 'twoFor25MemorialDay',
  tossIn: 'tossIn',
  newRegisterPage: 'newRegisterPage',
  facebookEmailRegistration: 'facebookEmailRegistration',
  upgradeActivationDateInSummary: 'upgradeActivationDateInSummary',
  productCountSelector: 'productCountSelector',
  mothersDay: 'mothersDay',
  twoProductsFor25TossIn: 'twoProductsFor25TossIn',
  quickLinksForMobile: 'quickLinksForMobile',
  onboardingOpenEvent: 'onboardingOpenEvent',
  animationMp4: 'animationMp4',
  tutorial: 'tutorial',
  facebookMainPageRedirect: 'facebookMainPageRedirect',
  delayBanner: 'delayBanner',
  makeupProductsAtTop: 'makeupProductsAtTop',
  productsCollections: 'productsCollections',
  unskipFlow: 'unskipFlow',
  bcrfDonationBanner: 'bcrfDonationBanner',
  queuePage: 'queuePage',
  newPaymentFlowWithCredits: 'newPaymentFlowWithCredits',
  mainPageCollections: 'mainPageCollections',
  emptyQueueClick: 'emptyQueueClick',
  blackFridayForSpecialFlows: 'blackFridayForSpecialFlows',
  blackFridayForFacebook: 'blackFridayForFacebook',
  smsThesisSplit20: 'smsThesisSplit20',
  smsThesisSplit50: 'smsThesisSplit50',
  smsThesisSplit80: 'smsThesisSplit80',
  smsThesisSplit100: 'smsThesisSplit100',
  facebookThesisSplit20: 'facebookThesisSplit20',
  facebookThesisSplit50: 'facebookThesisSplit50',
  facebookThesisSplit80: 'facebookThesisSplit80',
  facebookThesisSplit100: 'facebookThesisSplit100',
  facebookThesisSplitMen20: 'facebookThesisSplitMen20',
  facebookThesisSplitMen50: 'facebookThesisSplitMen50',
  facebookThesisSplitMen80: 'facebookThesisSplitMen80',
  facebookThesisSplitMen100: 'facebookThesisSplitMen100',
  restoreSubscriptionOrder: 'restoreSubscriptionOrder',
  facebookPage50Off: 'facebookPage50off',
  errorsForMultipleQueries: 'errorsForMultipleQueries',
  notesWithPopupOnProductPage: 'notesWithPopupOnProductPage',
  mobileSelectedFilters: 'mobileSelectedFilters',
  productPageForExtras: 'productPageForExtras',
  openTagFullRatingOnHover: 'openTagFullRatingOnHover',
  newCosmeticsBrandsFilter: 'newCosmeticsBrandsFilter',
  newParamsToReviews: 'newParamsToReviews',
  newViewSkincareProductPage: 'newViewSkincareProductPage',
  passwordRestoreWithToken: 'passwordRestoreWithToken',
  subscriptionLongProcessingBanner: 'SubscriptionLongProcessingBanner',
  skincareFeedOnMainPage: 'skincareFeedOnMainPage',
  firstTimeVisitModalWithTimer: 'firstTimeVisitModalWithTimer',
  skincareCarouselBanner: 'skincareCarouselBanner',
  skincareRecentlyAdded: 'skincareRecentlyAdded',
  algoliaSearch: 'algoliaSearch',
  moreRecommendations: 'moreRecommendations',
  queuePageForNonSubscribed: 'queuePageForNonSubscribed',
  flashSale: 'flashSale',
  skipOptions: 'skipOptions',
  subscriptionPlanMakeup: 'subscriptionPlanMakeup',
  resubscribeProductPage: 'resubscribeProductPage',
  resubscribeQueuePage: 'resubscribeQueuePage',
  resubscribeMembershipPage: 'resubscribeMembershipPage',
  newPayPalSDKIntegration: 'newPayPalSDKIntegration',
  incubatorNeonHeat: 'incubatorNeonHeat',
  pickOrgflowAndSweatcoin: 'pickOrgflowAndSweatcoin',
  upchargeForPerfumeCase: 'upchargeForPerfumeCase',
  proceedWithPrepaidCard: 'proceedWithPrepaidCard',
  pauseOneMonth: 'pauseOneMonth',
  newSubscriptionPaymentProcess: 'newSubscriptionPaymentProcess',
  experimentsRedirect: 'experimentsRedirect',
  wellnessBanner: 'wellnessBanner',
  wellnessBannerMainPage: 'wellnessBannerMainPage',
  billingDay1stDayOfTheMonth: 'billingDay1stDayOfTheMonth',
  mainPageUpcharge: 'mainPageUpcharge',
  specialFlowUpchargeText: 'specialFlowUpchargeText',
  unsubscribeShippingBillingIssues: 'unsubscribe:ShippingBillingIssues',
  supportFeedbackForm: 'supportFeedbackForm',
  improveSurvey: 'improveSurvey',
  longPassword: 'longPassword',
  fatherDayBambooGiftSet: 'fatherDayBambooGiftSet',
  fullBottle: 'fullBottle',
  fragranceConcepts: 'fragranceConcepts',
  crystalMasksBanner: 'crystalMasksBanner',
  recommendationsImprove: 'recommendationsImprove',
  queuePageBuyYourQueueBlock: 'queuePageBuyYourQueueBlock',
  removeWelcomePage: 'removeWelcomePage',
  premiumProductsForNotSubscribed: 'premiumProductsForNotSubscribed',
  appStoreBannerLanding: 'appStoreBannerLanding',
  appStoreBannerSite: 'appStoreBannerSite',
  queueOrderCOGS: 'queueOrderCOGS',
  unpauseOffers: 'unpauseOffers',
  caseSubscriptionCarouselBanner: 'caseSubscriptionCarouselBanner',
  mainFlowQuiz: 'mainFlowQuiz',
  upgradeProductPage: 'upgradeProductPage',
  makeupRecentlyAdded: 'makeupRecentlyAdded',
  pickPageQuizBanner: 'pickPageQuizBanner',
  productsBasedOnNotes: 'productsBasedOnNotes',
  collectionsForSale: 'collectionsForSale',
  productFeedUpgradeBanner: 'productFeedUpgradeBanner',
  upgradeSliderBanner: 'upgradeSliderBanner',
  prepaidPlansLandingPage: 'prepaidPlansLandingPage',
  upgradeLandingPage: 'upgradeLandingPage',
  coFlowTwoItems: 'coFlowTwoItems',
  newBannersOnMainPageSeptember: 'newBannersOnMainPageSeptember',
  newBannersOnMainPageOctober: 'newBannersOnMainPageOctober',
  hidePopularInStates: 'hidePopularInStates',
  hideFragranceFinder: 'hideFragranceFinder',
  hideFragranceHoroscope: 'hideHoroscope',
  hideGifts: 'hideGifts',
  flashSaleBanner: 'flashSaleBanner',
  separateWellness: 'separateWellness', // TODO remove with true statement after SB-412 is deployed on prod and enabled
  tasteMakersLanding: 'tasteMakersLanding',
  notesLinksInProductCard: 'notesLinksInProductCard',
  productSectionLabResults: 'productSectionLabResults', // TODO remove with true statement if SB-431 is deployed on prod
}


export default features
